import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
interface IPageAL2010 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Al2010Controller() {
    const vm: IPageAL2010 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            { nom: 'vaedsityp', largeur: 130 },
            { nom: 'dsimsg', largeur: 250 }
        ]
    };
}
